import React from 'react'

import { Box } from '@mui/material'

import { Organization } from '../../../../generated/graphql'

import OrgCode from '../../../admin/OrgCode'
import Stoplight from '../../../admin/Stoplight'

import { getOptionLabel } from './UserAccountSelect.utils'

interface Props {
    organization: Organization
    isGlobalAdmin: boolean
    isSelected?: boolean
}

const contentSx = {
    alignItems: 'baseline',
    display: 'inline-flex',
    gap: 0.5,
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
}

const labelSx = {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}

const AuctionOptionContent = ({ organization, isGlobalAdmin, isSelected = false }: Props) => {
    const { displayName, orgId, lastUpdated } = organization

    if (!isGlobalAdmin) {
        return (
            <Box component="span" sx={isSelected ? { color: 'primary.main' } : undefined}>
                {getOptionLabel(organization)}
            </Box>
        )
    }

    return (
        <>
            <Stoplight lastUpdated={lastUpdated} />
            <Box component="span" sx={{ ...contentSx, ...(isSelected ? { color: 'primary.main' } : {}) }}>
                <Box component="span" sx={labelSx}>
                    {displayName || orgId}
                </Box>
                <Box component="span" sx={{ flexShrink: 0 }}>
                    <OrgCode orgId={orgId || ''} />
                </Box>
            </Box>
        </>
    )
}

export default AuctionOptionContent
